import { ToggleButton, Tooltip } from "@heroui/react";
import { LightBulbIcon } from "@heroicons/react/24/outline";
import { LightBulbIcon as LightBulbIconSolid } from "@heroicons/react/24/solid";

interface CookModeToggleProps {
    readonly isSelected: boolean;
    readonly onChange: (selected: boolean) => void;
}

/**
 * Presentational "Cook mode" pill. Controlled by the recipe details banner,
 * which owns the single shared on/off state + the wake lock (see useWakeLock).
 * The banner renders this in two responsive slots (mobile strip + desktop
 * column) that are both always mounted, so sharing one state keeps the pills in
 * sync across layout switches and avoids duplicate locks.
 */
export const CookModeToggle = ({ isSelected, onChange }: CookModeToggleProps) => {
    return (
        <Tooltip delay={300}>
            <ToggleButton
                size="sm"
                variant="ghost"
                isSelected={isSelected}
                onChange={onChange}
                aria-label={isSelected ? "Cook mode on — screen staying awake" : "Cook mode — keep screen awake"}
                className="cook-mode-toggle"
            >
                {({ isSelected: selected }) => (
                    <>
                        {selected ? <LightBulbIconSolid className="size-4" /> : <LightBulbIcon className="size-4" />}
                        Cook mode
                    </>
                )}
            </ToggleButton>
            <Tooltip.Content>
                <p>{isSelected ? "Screen will stay on while you cook" : "Keep the screen on while you cook"}</p>
            </Tooltip.Content>
        </Tooltip>
    );
};
